import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { isNil } from 'lodash-es';
import { DateTime } from 'luxon';
import { CommonModule } from '@angular/common';
class LocalStorageService {
  setItem(key, value, expiration = null) {
    if (!key || isNil(value)) {
      return;
    }
    if (expiration) {
      const item = {
        expiresIn: expiration && expiration.duration ? DateTime.now().plus(expiration.duration).toISO() : null,
        data: value
      };
      return localStorage.setItem(key, JSON.stringify(item));
    }
    localStorage.setItem(key, typeof value !== 'object' ? value : JSON.stringify(value));
  }
  getItem(key, parse) {
    const storedString = localStorage.getItem(key);
    if (!storedString) {
      return null;
    }
    let parsedItem;
    try {
      parsedItem = JSON.parse(storedString);
    } catch (e) {
      parsedItem = storedString;
    }
    if (typeof parsedItem === 'object') {
      if (parsedItem?.expiresIn && parsedItem?.data && DateTime.now() > DateTime.fromISO(parsedItem.expiresIn)) {
        localStorage.removeItem(key);
        return null;
      }
      return !parse && !parsedItem?.expiresIn ? storedString : parsedItem?.data || parsedItem;
    }
    return parse ? parsedItem : storedString || null;
  }
  key(index) {
    return localStorage.key(index);
  }
  clear() {
    localStorage.clear();
  }
  removeItem(key) {
    localStorage.removeItem(key);
  }
  static {
    this.ɵfac = function LocalStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LocalStorageService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LocalStorageService,
      factory: LocalStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LocalStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class SessionStorageService {
  setItem(key, value, expiration = null) {
    if (!key || isNil(value)) {
      return;
    }
    if (expiration) {
      const item = {
        expiresIn: expiration && expiration.duration ? DateTime.now().plus(expiration.duration).toISO() : null,
        data: value
      };
      return sessionStorage.setItem(key, JSON.stringify(item));
    }
    sessionStorage.setItem(key, typeof value !== 'object' ? value : JSON.stringify(value));
  }
  getItem(key, parse) {
    const storedString = sessionStorage.getItem(key);
    if (!storedString) {
      return null;
    }
    let parsedItem;
    try {
      parsedItem = JSON.parse(storedString);
    } catch (e) {
      parsedItem = storedString;
    }
    if (typeof parsedItem === 'object') {
      if (parsedItem?.expiresIn && parsedItem?.data && DateTime.now() > DateTime.fromISO(parsedItem.expiresIn)) {
        sessionStorage.removeItem(key);
        return null;
      }
      return !parse && !parsedItem?.expiresIn ? storedString : parsedItem?.data || parsedItem;
    }
    return parse ? parsedItem : storedString || null;
  }
  key(index) {
    return sessionStorage.key(index);
  }
  clear() {
    sessionStorage.clear();
  }
  removeItem(key) {
    sessionStorage.removeItem(key);
  }
  static {
    this.ɵfac = function SessionStorageService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SessionStorageService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SessionStorageService,
      factory: SessionStorageService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SessionStorageService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
class StorageModule {
  static {
    this.ɵfac = function StorageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StorageModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StorageModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [LocalStorageService, SessionStorageService],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorageModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      providers: [LocalStorageService, SessionStorageService]
    }]
  }], null, null);
})();

/*
 * Public API Surface of storage
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LocalStorageService, SessionStorageService, StorageModule };
